const Resources = {

    table_headers: [
        { 
          text:     'Walking #',
          value:    'walking_number'
        },
        { 
            text:   'Door #',
            value:  'door_number'
        },
        { 
            text:   'Description',
            value:  'custom_description'
        },
        { 
            text:   'Sq feet',
            value:  'sq_ft'
        },
        { 
            text:   'Area',
            value:  'area'
        },
        { 
            text:   'Frequency',
            value:  'frequency'
        },
        { 
            text:   'Task',
            value:  'task'
        },
    ],

    filter_options:
    {
        show_properly_assigned_rooms: false,
        show_rooms_that_are: false,
    },

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Utilities',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Mass Delete Codes',
            href:   '/utilities-project-codes-mass-delete',
            arrow:  "",
        },
    ],

}

export default Resources;